"use strict";
exports.__esModule = true;
var rich_text_box_1 = require("../../../comment-box/rich-text-box/rich-text-box");
var probability_form_1 = require("../../../comment-box/probability-form/probability-form");
var range_form_1 = require("../../../comment-box/range-form/range-form");
var angular = require("angular");
var comment_box_form_1 = require("../../../comment-box/comment-box-form");
var accounting = require('accounting');
var InputScreen = /** @class */ (function () {
    function InputScreen(inputData, shadowInputData, invisibleInputData, invisibleShadowInputData, settings) {
        this.inputData = [];
        this.invisibleInputData = [];
        if (shadowInputData) {
            for (var i = 0; i < inputData.length; i++) {
                this.inputData.push(inputData[i]);
                shadowInputData[i].shadow = true;
                this.inputData.push(shadowInputData[i]);
            }
            if (invisibleInputData) {
                for (var i = 0; i < invisibleInputData.length; i++) {
                    this.invisibleInputData.push(invisibleInputData[i]);
                    invisibleShadowInputData[i].shadow = true;
                    this.invisibleInputData.push(invisibleShadowInputData[i]);
                }
            }
        }
        else {
            this.inputData = inputData;
            this.invisibleInputData = invisibleInputData;
        }
        this.settings = settings;
        this.parseDateObj(); // Parse Val into object if the input type is DATE
        this.makeDict();
        this.evaluate();
        this.placement = [];
        this.commentFormTypes = [];
        this.currentComments = [];
        this.universalTableComments = [];
        var dbCommentTypes = []; // Comment.type read from inputData
        this.timelineVisible = [];
        for (var i = 0; i < this.inputData.length; i++) {
            if (i < 2) {
                this.placement.push("bottom");
            }
            else if (i > this.inputData.length - 3) {
                this.placement.push("top");
            }
            else {
                this.placement.push("right");
            }
            if (this.inputData[i].Comment !== undefined) {
                var comments = this.inputData[i].Comment;
                var latestCommentType = comments[comments.length - 1].type;
                var latestCommentMsg = comments[comments.length - 1].msg;
                dbCommentTypes.push(latestCommentType);
                if (latestCommentType === 'Probability') {
                    this.currentComments.push(new probability_form_1.ProbabilityForm(latestCommentMsg));
                }
                else if (latestCommentType === 'Range') {
                    this.currentComments.push(new range_form_1.RangeForm(latestCommentMsg));
                }
                else {
                    try {
                        var latestComment = decodeURIComponent(latestCommentMsg);
                        this.currentComments.push(new rich_text_box_1.RichTextBox(latestComment));
                    }
                    catch (exp) {
                        this.currentComments.push(new rich_text_box_1.RichTextBox(latestCommentMsg));
                        console.warn("odd comment : " + latestCommentMsg);
                    }
                }
                this.universalTableComments.push(comments[comments.length - 1].universalTableComment);
            }
            else {
                this.currentComments.push(undefined);
                this.universalTableComments.push(undefined);
                dbCommentTypes.push(undefined);
            }
            this.timelineVisible.push(false);
            this.commentFormTypes.push(this.inputData[i].Form);
        }
        this.modifyCommentInfo(dbCommentTypes);
        this.copyToOrig();
    }
    InputScreen.prototype.modifyCommentInfo = function (dbCommentTypes) {
        for (var i = 0; i < this.currentComments.length; i++) {
            var type = this.commentFormTypes[i];
            var comment = this.currentComments[i];
            if (type === 'Probability') {
                if (this.settings.showProb) {
                    if (dbCommentTypes[i] !== 'Probability') {
                        this.currentComments[i] = comment ? comment.toCommentForm('Probability') : new probability_form_1.ProbabilityForm('');
                    }
                }
                else {
                    this.commentFormTypes[i] = undefined;
                    if (dbCommentTypes[i] === 'Probability') {
                        this.currentComments[i] = new rich_text_box_1.RichTextBox(comment.toRichTextVal());
                    }
                    else {
                        this.currentComments[i] = comment ? comment : new rich_text_box_1.RichTextBox('');
                    }
                }
            }
            else if (type === 'Range') {
                if (this.settings.showRange) {
                    if (dbCommentTypes[i] !== 'Range') {
                        this.currentComments[i] = comment ? comment.toCommentForm('Range') : new range_form_1.RangeForm('');
                    }
                }
                else {
                    this.commentFormTypes[i] = undefined;
                    if (dbCommentTypes[i] === 'Range') {
                        this.currentComments[i] = new rich_text_box_1.RichTextBox(comment.toRichTextVal());
                    }
                    else {
                        this.currentComments[i] = comment ? comment : new rich_text_box_1.RichTextBox('');
                    }
                }
            }
            else {
                this.commentFormTypes[i] = undefined;
                if (dbCommentTypes[i] === 'Probability' || dbCommentTypes[i] === 'Range') {
                    this.currentComments[i] = new rich_text_box_1.RichTextBox(comment.toRichTextVal());
                }
                else {
                    this.currentComments[i] = comment ? comment : new rich_text_box_1.RichTextBox('');
                }
            }
        }
    };
    InputScreen.prototype.decode = function (string) {
        try {
            return decodeURIComponent(string);
        }
        catch (e) {
            return string;
        }
    };
    InputScreen.prototype.makeDict = function () {
        this.inputKeyDict = {};
        this.shadowInputKeyDict = {};
        for (var i = 0; i < this.inputData.length; i++) {
            if (this.inputData[i].shadow === undefined) {
                this.inputKeyDict[this.inputData[i].Key] = this.inputData[i];
            }
            else if (this.inputData[i].shadow === true) {
                this.shadowInputKeyDict[this.inputData[i].Key] = this.inputData[i];
            }
        }
        if (this.invisibleInputData) {
            for (var i = 0; i < this.invisibleInputData.length; i++) {
                if (this.invisibleInputData[i].shadow === undefined) {
                    this.inputKeyDict[this.invisibleInputData[i].Key] = this.invisibleInputData[i];
                }
                else if (this.invisibleInputData[i].shadow === true) {
                    this.shadowInputKeyDict[this.invisibleInputData[i].Key] = this.invisibleInputData[i];
                }
            }
        }
    };
    InputScreen.prototype.evaluate = function () {
        this.makeDict();
        for (var i = 0; i < this.inputData.length; i++) {
            if (this.inputData[i].Type === "LIVE") {
                var formula = this.inputData[i].Formula;
                var expr = Parser.parse(formula);
                var operateOnKeys = this.inputData[i].OperateOnKeys;
                var evaluation = {};
                var val = void 0;
                if (this.inputData[i].shadow === undefined) {
                    val = this.getValForLiveType(operateOnKeys, evaluation, expr, this.inputKeyDict);
                }
                else if (this.inputData[i].shadow === true) {
                    val = this.getValForLiveType(operateOnKeys, evaluation, expr, this.shadowInputKeyDict);
                }
                if (operateOnKeys.length == 1) {
                    this.inputData[i].Val = val;
                }
                else if (this.inputData[i].Units.toLowerCase().indexOf("year") === -1) {
                    this.inputData[i].Val = accounting.formatNumber(val, this.inputData[i].Precision);
                }
                else {
                    this.inputData[i].Val = accounting.toFixed(val, this.inputData[i].Precision);
                }
            }
        }
    };
    InputScreen.prototype.getValForLiveType = function (operateOnKeys, evaluation, expr, inputKeyDict) {
        if (operateOnKeys.length == 1) {
            if (operateOnKeys[0] in inputKeyDict && 'Val' in inputKeyDict[operateOnKeys[0]]) {
                return inputKeyDict[operateOnKeys[0]].Val;
            }
        }
        else {
            for (var j = 0; j < operateOnKeys.length; j++) {
                var key = operateOnKeys[j];
                evaluation[key] = inputKeyDict[key]['Type'] === 'DISTRIBUTION' ?
                    evaluation[key] = inputKeyDict[key].Val[1] :
                    evaluation[key] = inputKeyDict[key].Val;
            }
            return expr.evaluate(evaluation);
        }
    };
    InputScreen.prototype.toggleTimeLineAt = function (index) {
        this.timelineVisible[index] = !this.timelineVisible[index];
    };
    InputScreen.prototype.copyToOrig = function () {
        this.origInputData = [];
        for (var i = 0; i < this.inputData.length; i++) {
            this.origInputData.push(jQuery.extend(true, {}, this.inputData[i]));
        }
        this.origCurrentComments = angular.copy(this.currentComments);
    };
    InputScreen.prototype.isSameArrayOfNumber = function (inputData, origData) {
        var dirtyCount = 0;
        if (inputData.Val.length !== origData.Val.length) {
            dirtyCount++;
        }
        else {
            for (var i = 0; i < inputData.Val.length; i++) {
                if (inputData.Val[i] != origData.Val[i]) {
                    dirtyCount++;
                }
                else {
                    this.markFieldAsPristine(inputData, i);
                }
            }
        }
        return dirtyCount == 0;
    };
    InputScreen.prototype.markFieldAsPristine = function (inputData, index) {
        // Replace 'key+' with the actual ID prefix of your input field
        var inputFieldId = inputData.Key + index;
        var inputField = angular.element(document.getElementById(inputFieldId));
        // Find the associated ngModel controller and mark it as pristine
        var ngModelController = inputField.controller('ngModel');
        // Make sure the ngModelController exists before trying to set it as pristine
        if (ngModelController) {
            ngModelController.$setPristine();
        }
        else {
            console.log('ngModelController not found');
        }
    };
    InputScreen.prototype.isSameArrayOfNumber = function (inputData, origData) {
        var dirtyCount = 0;
        if (inputData.Val.length !== origData.Val.length) {
            dirtyCount++;
        }
        else {
            for (var i = 0; i < inputData.Val.length; i++) {
                if (inputData.Val[i] != origData.Val[i]) {
                    dirtyCount++;
                }
                else {
                    this.markFieldAsPristine(inputData, i);
                }
            }
        }
        return dirtyCount == 0;
    };
    InputScreen.prototype.markFieldAsPristine = function (inputData, index) {
        // Replace 'key+' with the actual ID prefix of your input field
        var inputFieldId = inputData.Key + index;
        var inputField = angular.element(document.getElementById(inputFieldId));
        // Find the associated ngModel controller and mark it as pristine
        var ngModelController = inputField.controller('ngModel');
        // Make sure the ngModelController exists before trying to set it as pristine
        if (ngModelController) {
            ngModelController.$setPristine();
        }
        else {
            console.log('ngModelController not found');
        }
    };
    InputScreen.prototype.getTextContent = function (element) {
        if (!element) {
            return undefined;
        }
        if (typeof element['outerText'] !== 'undefined') {
            return element['outerText'];
        }
        return element['textContent'];
    };
    InputScreen.prototype.parseHTMLtoString = function (comment) {
        var str = "";
        for (var i = 0; i < $.parseHTML(comment).length; i++) {
            str += this.getTextContent($.parseHTML(comment)[i]) + " ";
        }
        return str.trim();
    };
    InputScreen.prototype.trimComment = function (comment) {
        if (comment && comment.length > 50) {
            comment = comment.substring(0, 49) + "...";
        }
        return comment;
    };
    InputScreen.prototype.createCurrentCommentStr = function (currentComments) {
        var currentCommentStrs = [];
        for (var i = 0; i < currentComments.length; i++) {
            var comment = currentComments[i];
            var universalTableComment = this.universalTableComments[i] ? '(' + this.universalTableComments[i] + ') ' : '';
            if (comment) {
                currentCommentStrs.push(this.trimComment(universalTableComment + comment.toCommentStr()));
            }
            else {
                currentCommentStrs.push(this.trimComment(universalTableComment));
            }
        }
        return currentCommentStrs;
    };
    InputScreen.prototype.addDecodedMsgToCommentModalData = function (commentModalData, commentMsgs) {
        for (var i = 0; i < commentMsgs.length; i++) {
            var commentMsg = commentMsgs[i];
            var commentItem = commentModalData[i + 1];
            if (!commentItem.type || typeof commentItem.type === 'undefined') {
                var decodedMsg = this.decode(commentMsg);
                commentItem.decodedMsg = decodedMsg;
                var parsedHTML = $.parseHTML(decodedMsg);
                commentItem.msgStr = (parsedHTML && parsedHTML.length > 0 && typeof this.getTextContent(parsedHTML[0]) !== 'undefined') ?
                    this.trimComment(this.parseHTMLtoString(decodedMsg)) :
                    this.trimComment(decodedMsg);
            }
            else {
                try {
                    var commentBoxForm = new comment_box_form_1.CommentBoxForm();
                    commentBoxForm.keysOrder = JSON.parse(commentMsg).keysOrder;
                    commentBoxForm.parseFormComments(commentMsg);
                    commentItem.decodedMsg = commentBoxForm;
                    commentItem.msgStr = commentBoxForm.toCommentStr();
                }
                catch (e) {
                    commentItem.decodedMsg = commentMsg;
                    commentItem.decodedMsg = this.trimComment(commentMsg);
                }
            }
        }
        return commentModalData;
    };
    InputScreen.prototype.isInputItemValueDirty = function (i) {
        if (this.inputData[i].Val instanceof Array) {
            return !this.isSameArrayOfNumber(this.inputData[i], this.origInputData[i]);
        }
        if (this.inputData[i].Val instanceof Object) {
            return (this.inputData[i].Val.month !== this.origInputData[i].Val.month ||
                this.inputData[i].Val.year !== this.origInputData[i].Val.year);
        }
        return '' + this.inputData[i].Val !== '' + this.origInputData[i].Val;
    };
    InputScreen.prototype.isInputItemCommentDirty = function (i) {
        return !angular.equals(this.origCurrentComments[i], this.currentComments[i]);
    };
    InputScreen.prototype.isInputItemDirty = function (i) {
        // let result: boolean = false;
        // if (this.inputData[i].Val instanceof Array) {
        //     result = !this.isSameArrayOfNumber(
        //         this.inputData[i].Val, this.origInputData[i].Val)
        // } else if (this.inputData[i].Val instanceof Object) {
        //     result = (this.inputData[i].Val.month !== this.origInputData[i].Val.month ||
        //         this.inputData[i].Val.year !== this.origInputData[i].Val.year);
        // } else {
        //     if ('' + this.inputData[i].Val !== '' + this.origInputData[i].Val) {
        //         result = true;
        //     }
        // }
        //
        // if (!angular.equals(this.origCurrentComments[i], this.currentComments[i])) {
        //     result = true;
        // }
        //
        // return result;
        return this.isInputItemValueDirty(i) || this.isInputItemCommentDirty(i);
    };
    InputScreen.prototype.isDirty = function () {
        var result = false;
        for (var i = 0; i < this.inputData.length; i++) {
            if (this.isInputItemDirty(i)) {
                result = true;
                break;
            }
        }
        return result;
    };
    InputScreen.prototype.insertZero = function (inputNumber) {
        if (typeof inputNumber === 'string') {
            var result = void 0;
            if (inputNumber[0] === '.') {
                result = ['0', inputNumber].join('');
            }
            else if (inputNumber[0] === '-' && inputNumber[1] === '.') {
                result = [inputNumber.slice(0, 1), '0', inputNumber.slice(1)].join('');
            }
            else {
                result = inputNumber;
            }
            return result;
        }
        else {
            return inputNumber;
        }
    };
    InputScreen.prototype.validateNumber = function (val) {
        if (val.length === 3 && typeof val !== 'string') {
            for (var i = 0; i < val.length; i++) {
                val[i] = this.insertZero(val[i]);
            }
        }
        else {
            val = this.insertZero(val);
        }
        return val;
    };
    InputScreen.prototype.returnPacket = function () {
        var returnData = [];
        for (var i = 0; i < this.inputData.length; i++) {
            if (!this.inputData[i]['shadow'] && this.isInputItemDirty(i)) {
                this.inputData[i].Val = this.validateNumber(this.inputData[i].Val);
                returnData.push({
                    Val: this.inputData[i].Val,
                    Key: this.inputData[i].Key,
                    Comment: this.inputData[i].Comment
                });
            }
        }
        return returnData;
    };
    InputScreen.prototype.parseDateObj = function () {
        for (var i = 0; i < this.inputData.length; i++) {
            if (this.inputData[i].Type === "DATE" &&
                typeof (this.inputData[i].Val) === "string") {
                var split = this.inputData[i].Val.split(" ");
                this.inputData[i].Val = { 'month': split[0], 'year': split[1] };
            }
        }
    };
    InputScreen.prototype.parseDateString = function (inputs) {
        for (var i = 0; i < inputs.length; i++) {
            if (inputs[i].Val instanceof Object && inputs[i].Val.month) {
                inputs[i].Val = inputs[i].Val.month + " " + inputs[i].Val.year;
            }
        }
        return inputs;
    };
    InputScreen.prototype.isInputTypeDropdown = function (i) {
        return (["DROPDOWN", "DATABASE_DROPDOWN"].includes(this.inputData[i].Type));
    };
    InputScreen.prototype.isDropdownTagsChanged = function () {
        for (var i = 0; i < this.inputData.length; i++) {
            if (this.isInputTypeDropdown(i) && this.isInputItemValueDirty(i)) {
                return true;
            }
        }
        return false;
    };
    InputScreen.prototype.isInputDataValueChanged = function () {
        for (var i = 0; i < this.inputData.length; i++) {
            if (this.isInputItemValueDirty(i)) {
                return true;
            }
        }
        return false;
    };
    InputScreen.prototype.generateSaveData = function (user) {
        for (var i = 0; i < this.inputData.length; i++) {
            if (this.isInputItemDirty(i)) {
                // Data structure is last value - current comment.
                // No good.
                // Horrible
                var d = new Date();
                var saveOn = d.toDateString().substring(0, d.toDateString().length - 4) +
                    d.toTimeString().split(' ')[0] + " " + d.getFullYear();
                var commentType = this.commentFormTypes[i];
                var commentMsg = (commentType && typeof commentType !== 'undefined') ?
                    JSON.stringify(this.currentComments[i]) :
                    encodeURIComponent(('val' in this.currentComments[i]) ?
                        this.currentComments[i].val :
                        this.currentComments[i]);
                var newComment = {
                    SavedBy: user,
                    SavedOn: encodeURIComponent(saveOn),
                    lastVal: this.origInputData[i].Val,
                    msg: commentMsg,
                    type: commentType
                };
                if (!this.inputData[i].Comment) {
                    this.inputData[i].Comment = [];
                }
                this.inputData[i].Comment.push(newComment);
                this.universalTableComments[i] = undefined;
            }
        }
        // Parse Val into string if the input type is DATE
        return this.parseDateString(this.returnPacket());
    };
    return InputScreen;
}());
exports.InputScreen = InputScreen;
exports["default"] = InputScreen;
//# sourceMappingURL=input-screen.js.map


// WEBPACK FOOTER //
// ./app/widgets/action/input-screen/app/js/logic/input-screen.js